// Copyright 2025 andrewzeck
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     https://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// Copyright 2021 andrewzeck
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import React from "react";
import Table from "../../components/Table/Table";
import tableStyles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import { grayColor, primaryColor, successColor, infoColor, dangerColor } from "assets/jss/emjayTheme.js";
import _ from "lodash";
import { withStyles } from "@material-ui/core/styles";

// Custom styles for the API dialog
const styles = theme => ({
  ...tableStyles(theme),
  dialogContent: {
    padding: "20px 24px 0",
    overflowY: "auto"
  },
  dialogTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& span": {
      fontWeight: 500,
      fontSize: "1.25rem"
    }
  },
  formControl: {
    marginTop: "16px",
    marginBottom: "8px"
  },
  selectContainer: {
    display: "flex",
    alignItems: "center",
    position: "relative"
  },
  removeButton: {
    marginLeft: "8px",
    padding: "4px"
  },
  sectionTitle: {
    fontSize: "1.25rem",
    fontWeight: 500,
    marginTop: "8px",
    marginBottom: "24px",
    color: primaryColor[0]
  },
  sectionSubtitle: {
    fontSize: "1rem",
    fontWeight: 500,
    marginTop: "24px",
    marginBottom: "16px",
    color: grayColor[1]
  },
  formFieldsContainer: {
    marginTop: "16px",
    marginBottom: "24px",
    paddingTop: "8px",
    borderTop: `1px solid ${grayColor[9]}`
  },
  checkboxLabel: {
    marginLeft: 0,
    marginTop: "16px"
  },
  nestedSectionTitle: {
    fontSize: "1rem",
    fontWeight: 500,
    marginTop: "16px",
    marginBottom: "8px",
    color: grayColor[0],
    borderBottom: `1px solid ${grayColor[9]}`,
    paddingBottom: "8px"
  },
  dialogActions: {
    padding: "16px 24px",
    justifyContent: "flex-end",
    borderTop: `1px solid ${grayColor[9]}`
  },
  actionButton: {
    marginLeft: "8px"
  },
  lightspeedSection: {
    marginTop: "16px",
    marginBottom: "24px",
    paddingTop: "8px",
    borderTop: `1px solid ${grayColor[9]}`,
    backgroundColor: "#f8f9fa",
    padding: "16px",
    borderRadius: "4px"
  },
  shopButton: {
    marginBottom: "16px"
  },
  instructionsText: {
    fontSize: "0.875rem",
    color: grayColor[1],
    fontStyle: "italic",
    marginTop: "8px",
    padding: "8px 12px",
    backgroundColor: "#f8f9fa",
    borderRadius: "4px",
    border: `1px solid ${grayColor[9]}`
  }
});

import RegularButton from '../../components/CustomButtons/Button';
import Overlay from "../../components/Overlay/Overlay";
import { connect } from "react-redux";
import { SmallUppercase } from "../../text";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import CustomInput from "../../components/CustomInput/CustomInput";
import Check from "@material-ui/icons/Check";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { getSupportedAPIs, createRetailerAPICredentials, updateRetailerAPICredentials, deleteRetailerAPICredentials, testRetailerAPICredentials, getLightspeedShops, getLightspeedRetailMasterTokens} from "../../api";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  Divider
} from "@material-ui/core";

class SellerAPIDialog extends React.Component {
  constructor(props) {
    super(props);
    console.log('[SellerAPIDialog] constructor called with props:', props);
    this.state = {
      error:null,
      loading:true,
      providers:[],
      selected_provider:null,
      credentials:{},
      lightspeedShops: [],
      selectedShop: null,
      loadingShops: false,
      masterTokens: [],
      loadingMasterTokens: false,
      selectedMasterToken: null
    }
  }

  _loadProviders(){
    const {
      seller
    } = this.props;
    this.setState({ loading: true }, () => {
      getSupportedAPIs().then((results)=>{
        let selected = null;
        let currentCredentials = seller.api_credentials || {};
        console.log(`apis: ${JSON.stringify(results.data)}`);
        if(results && results.data && results.data.length){
          console.log(`received ${results.data.length}`);
          if(_.get(seller, 'api_credentials.provider')) {
            let provider = _.find(results.data, {provider:seller.api_credentials.provider});
            if(provider){
              selected = provider;
              console.log(`selected provider: ${JSON.stringify(selected)}`);
              currentCredentials = _.cloneDeep(seller.api_credentials || selected_provider);
            } else {
              console.log(`provider not found: ${seller.api_credentials.provider}`);
            }
          }
          this.setState({ providers:results.data, selected_provider:selected, credentials:currentCredentials, loading: false });
        }
        else {
          this.setState({loading:false})
        }
      }).catch((error) => {
        console.log(`error: ${JSON.stringify(error)}`);
        this.setState({loading:false})
      })
    });
  }

  componentDidMount = () =>{
    console.log(`[SellerAPIDialog] componentDidMount called with props:`, this.props);
    this._loadProviders();
  }

  onProviderClick = (e) => {
    let value = e.target.value;
    console.log('select provider:',value);
    let currProvider = this.state.selected_provider;
    const selectedProvider = this.state.providers.find(p => p.provider === e.target.value);
    let credentials = _.cloneDeep(this.state.credentials);
    if(!currProvider || currProvider.provider !== selectedProvider.provider) {
      credentials = _.cloneDeep(selectedProvider);
      console.log('switching provider:', selectedProvider.provider);
    }
    this.setState({ 
      selected_provider: selectedProvider, 
      credentials: credentials,
      lightspeedShops: [],
      selectedShop: null
    });
  };

  submit = () => {
    const {
      seller
    } = this.props;
    const {
      credentials, 
      selected_provider
    } = this.state;
    this.setState({loading: true}, () => {
      let body = {
        fields: credentials,
        provider: selected_provider.provider
      }
      if(_.isEmpty(seller.api_credentials)) {
        createRetailerAPICredentials(seller.store_id, body).then( () => {
          this.setState({loading:false})
          this.props.closeAPIDialog(true)
        }).catch( (error) => {
          if (error.response && error.response.status === 500 && error.response.data) {
            this.setState({
              loading: false,
              error: typeof error.response.data === 'object' 
                ? JSON.stringify(error.response.data, null, 2)
                : error.response.data
            });
          } else {
            this.setState({
              loading: false,
              error: error.response?.data?.message || 'An error occurred while creating credentials'
            });
          }
          this.setState({loading:false});
        })
      } else {
        updateRetailerAPICredentials(seller.store_id, body).then( () => {
          this.setState({loading:false})
          this.props.closeAPIDialog(true)
        }).catch( (error) => {
          if (error.response && error.response.status === 500 && error.response.data) {
            this.setState({
              loading: false,
              error: typeof error.response.data === 'object' 
                ? JSON.stringify(error.response.data, null, 2)
                : error.response.data
            });
          } else {
            this.setState({
              loading: false,
              error: error.response?.data?.message || 'An error occurred while updating credentials'
            });
          }
          this.setState({loading:false});
        })
      }
    });
  };
  testCredentials = () => {
    const { seller } = this.props;
    let { credentials, selected_provider } = this.state;
    
    // Validate that we have credentials to test
    if (!selected_provider) {
      this.setState({ 
        error: 'Please select an API provider first'
      });
      return;
    }
    
    // Use existing credentials if none are set up yet
    if(_.isEmpty(credentials)) {
      credentials = seller.api_credentials;
    }
    
    // Check for required fields
    if (selected_provider.required_fields && selected_provider.required_fields.length > 0) {
      const missingFields = selected_provider.required_fields.filter(field => 
        !credentials[field] || credentials[field].trim() === ''
      );
      
      if (missingFields.length > 0) {
        const formattedFields = missingFields.map(field => 
          field.replace(/_/g, ' ')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
        ).join(', ');
        
        this.setState({ 
          error: `Please fill in all required fields: ${formattedFields}`
        });
        return;
      }
    }
    
    console.log('Testing credentials:', credentials);
    
    this.setState({ loading: true, error: null }, () => {
      testRetailerAPICredentials(seller.store_id, credentials)
        .then((results) => {
          console.log('Test results:', results);
          
          // If the response contains a download URL
          if (results.data && results.data.url) {
            // Create a temporary link element
            const link = document.createElement('a');
            link.href = results.data.url;
            
            // Set the filename for the download
            link.download = `${seller.store_id}_api_test_results.json`;
            
            // Append to body, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            this.setState({
              loading: false, 
              error: null,
              successMessage: 'API credentials tested successfully. Test results have been downloaded.'
            });
            
            // Clear success message after 5 seconds
            setTimeout(() => {
              this.setState({ successMessage: null });
            }, 5000);
          }
          else {
            this.setState({
              loading: false, 
              error: 'No results returned from API test'
            });
          }
        })
        .catch((error) => {
          console.error('Test credentials error:', error);
          
          // Handle different error scenarios
          if (error.response && error.response.status === 500 && error.response.data) {
            // Format JSON error for better readability
            const errorMessage = typeof error.response.data === 'object' 
              ? JSON.stringify(error.response.data, null, 2)
              : error.response.data;
              
            this.setState({
              loading: false,
              error: `API Error: ${errorMessage}`
            });
          } else if (error.response && error.response.data && error.response.data.message) {
            this.setState({
              loading: false,
              error: `API Error: ${error.response.data.message}`
            });
          } else {
            this.setState({
              loading: false,
              error: 'An error occurred while testing the API credentials. Please verify your inputs and try again.'
            });
          }
        });
    });
  }
  removeCredentials = () => {
    const {
      seller
    } = this.props;
    deleteRetailerAPICredentials(seller.store_id).then( () => {
      this.setState({loading:false})
      this.props.closeAPIDialog(true)
    }).catch( (error) => {
      console.log('removeCredentials error:', JSON.stringify(error));
      if (error.response && error.response.status === 500 && error.response.data) {
        this.setState({
          loading: false,
          error: typeof error.response.data === 'object' 
            ? JSON.stringify(error.response.data, null, 2)
            : error.response.data
        });
      } else {
        this.setState({
          loading: false,
          error: error.response?.data?.message || 'An error occurred while testing credentials'
        });
      }
    })
  }

  fetchLightspeedRetailMasterTokens = () => {
    this.setState({ loadingMasterTokens: true, error: null }, () => {
      getLightspeedRetailMasterTokens()
        .then((response) => {
          console.log('Lightspeed retail master tokens response:', response.data);
          if (response.data) {
            // Ensure we always have an array
            let tokens = response.data;
            if (!Array.isArray(tokens)) {
              tokens = [tokens];
            }
            
            this.setState({
              masterTokens: tokens,
              loadingMasterTokens: false
            });
          } else {
            this.setState({
              loadingMasterTokens: false,
              error: 'No master tokens found in response'
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching Lightspeed retail master tokens:', error);
          this.setState({
            loadingMasterTokens: false,
            error: error.response?.data?.message || 'Failed to fetch Lightspeed retail master tokens'
          });
        });
    });
  }

  fetchLightspeedShops = () => {
    const { seller } = this.props;
    const { credentials } = this.state;
    
    this.setState({ loadingShops: true, error: null }, () => {
      getLightspeedShops(seller.store_id, credentials)
        .then((response) => {
          console.log('Lightspeed shops response:', response.data);
          if (response.data) {
            // Ensure we always have an array, even if the API returns a single object
            let shops = response.data;
            if (!Array.isArray(shops)) {
              shops = [shops];
            }
            
            this.setState({
              lightspeedShops: shops,
              loadingShops: false
            });
          } else {
            this.setState({
              loadingShops: false,
              error: 'No shops found in response'
            });
          }
        })
        .catch((error) => {
          console.error('Error fetching Lightspeed shops:', error);
          this.setState({
            loadingShops: false,
            error: error.response?.data?.message || 'Failed to fetch Lightspeed shops'
          });
        });
    });
  }

  onShopSelect = (e) => {
    const shopId = e.target.value;
    const selectedShop = this.state.lightspeedShops.find(shop => shop.shopID === shopId);
    
    this.setState({ selectedShop }, () => {
      // Update credentials with the selected shop ID
      const updatedCredentials = { ...this.state.credentials };
      updatedCredentials.item_shop_id = shopId;
      this.setState({ credentials: updatedCredentials });
    });
  }

  onMasterTokenSelect = (e) => {
    const accountId = e.target.value;
    const selectedToken = this.state.masterTokens.find(token => token.account_id === accountId);
    
    this.setState({ selectedMasterToken: selectedToken, credentials: { ...this.state.credentials, account_id: selectedToken.account_id } });
  }

  renderObjectCredentials = (credentialsObj, classes) => {
    const ignoreFields = ['_id', 'account', 'provider', '__v', 'master', 'is_active', 'required_fields', 'provide_oauth_link', 'instructions', 'access_token', 'refresh_token', 'account_id', 'last_updated'];
    let requiredFields = this.state.selected_provider.required_fields;
    
    return Object.keys(credentialsObj).map((key) => {
      let value = credentialsObj[key];
      if(ignoreFields.includes(key)) {
        console.log(`ignoring field: ${key}`);
        return null;
      }
      
      // Format field label for better readability
      const formattedLabel = key
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      
      if (_.isString(value)) {
        if(value.indexOf('{store_id}') !== -1) {
          value = value.replace('{store_id}', this.props.seller.store_id);
        }
        return (
          <GridItem xs={12} sm={6} md={4} key={key}>
            <CustomInput
              labelText={`${formattedLabel}${requiredFields.includes(key) ? ' *' : ''}`}
              formControlProps={{
                fullWidth: true,
                margin: "dense"
              }}
              inputProps={{
                value: value,
                onChange: (e) => {
                  _.set(this.state.credentials, key, e.currentTarget.value);
                  this.setState({ credentials:this.state.credentials });
                }
              }}
            />
          </GridItem>
        );
      } else if (_.isBoolean(value)) {
        return (
          <GridItem xs={12} sm={6} md={4} key={key}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={value}
                  onChange={() => {
                    const newValue = !value;
                    _.set(this.state.credentials, key, newValue);
                    this.setState({ credentials:this.state.credentials });
                  }}
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot,
                  }}
                />
              }
              label={formattedLabel}
              className={classes.checkboxLabel}
            />
          </GridItem>
        );
      } else if (_.isNumber(value)) {
        return (
          <GridItem xs={12} sm={6} md={4} key={key}>
            <CustomInput
              labelText={`${formattedLabel}${requiredFields.includes(key) ? ' *' : ''}`}
              formControlProps={{
                fullWidth: true,
                margin: "dense"
              }}
              inputProps={{
                value: value,
                type: 'number',
                onChange: (e) => {
                  _.set(this.state.credentials, key, parseFloat(e.currentTarget.value));
                  this.setState({ credentials:this.state.credentials });
                }
              }}
            />
          </GridItem>
        );
      } else if (_.isObject(value)) {
        const nestedFields = this.renderObjectCredentials(value, classes);
        return (
          <GridItem xs={12} key={key}>
            <h4 className={classes.nestedSectionTitle}>{formattedLabel}</h4>
            <GridContainer>{nestedFields}</GridContainer>
          </GridItem>
        );
      }
      return null;
    });
  };

  render(){
    let { loading, error, successMessage, selected_provider, providers, credentials, lightspeedShops, selectedShop, loadingShops, masterTokens, loadingMasterTokens, selectedMasterToken } = this.state;
    let { seller, classes } = this.props;
    
    let formFields = [];
    if(!loading && selected_provider) {
      formFields = _.compact(this.renderObjectCredentials(credentials, classes));
    }

    return (
      <Dialog open={true} maxWidth="lg" fullWidth>
        {loading && <Overlay type="loading" />}
        
        {error && (
          <Overlay
            type="error"
            message={error}
            dismiss={
              <RegularButton
                size="sm"
                color="primary"
                onClick={() => {
                  this.setState({ error: null });
                }}
              >
                Dismiss
              </RegularButton>
            }
          />
        )}
        
        {successMessage && (
          <Overlay
            type="success"
            message={successMessage}
            dismiss={
              <RegularButton
                size="sm"
                color="primary"
                onClick={() => {
                  this.setState({ successMessage: null });
                }}
              >
                Dismiss
              </RegularButton>
            }
          />
        )}
        
        <DialogTitle>
          <div className={classes.dialogTitleContainer}>
            <span>{seller.store_id} - {seller.name}</span>
          </div>
        </DialogTitle>
        
        <DialogContent className={classes.dialogContent}>
          <h3 className={classes.sectionTitle}>API Configuration</h3>
          
          <GridContainer>
            <GridItem xs={12} sm={6}>
              <FormControl fullWidth className={classes.formControl}>
                <InputLabel 
                  htmlFor="api-provider-select" 
                  className={classes.selectLabel}
                >
                </InputLabel>
                <div className={classes.selectContainer}>
                  <Select
                    id="api-provider-select"
                    value={selected_provider ? selected_provider.provider : ""}
                    onChange={(e) => this.onProviderClick(e)}
                    MenuProps={{ className: classes.selectMenu }}
                    classes={{ select: classes.select }}
                    fullWidth
                    displayEmpty
                    inputProps={{
                      name: "apiProvider",
                    }}
                  >
                    <MenuItem value="" disabled>
                      Choose API
                    </MenuItem>
                    {this.state.providers.map((option, i) => (
                      <MenuItem
                        key={`provider_${i}`}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelectedMultiple,
                        }}
                        value={option.provider}
                      >
                        {option.provider}
                      </MenuItem>
                    ))}
                  </Select>
                  
                  {selected_provider && (
                    <IconButton
                      className={classes.removeButton}
                      onClick={() => {
                        this.setState({selected_provider:null})
                      }}
                    >
                      <RemoveCircleIcon color="error" />
                    </IconButton>
                  )}
                </div>
              </FormControl>
            </GridItem>
            
            {selected_provider && selected_provider.instructions && (
              <GridItem xs={12} sm={8}>
                <div className={classes.instructionsText}>
                  {selected_provider.instructions}
                </div>
              </GridItem>
            )}
          </GridContainer>
          
          {formFields.length > 0 && (
            <div className={classes.formFieldsContainer}>
              <h4 className={classes.sectionSubtitle}>Credentials</h4>
              <GridContainer>
                {formFields}
              </GridContainer>
            </div>
          )}

          {selected_provider && selected_provider.provider === 'Lightspeed Retail' && (
            <div className={classes.lightspeedSection}>
              <h4 className={classes.sectionSubtitle}>Lightspeed Account Management</h4>
              
              {/* Master Account Display */}
              {credentials.account_master && (
                <GridContainer>
                  <GridItem xs={12} sm={6}>
                    <CustomInput
                      labelText="Account ID"
                      formControlProps={{
                        fullWidth: true,
                        margin: "dense"
                      }}
                      inputProps={{
                        value: credentials.account_id || '',
                        disabled: true
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={true}
                          disabled={true}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                          }}
                        />
                      }
                      label="Master Account"
                      className={classes.checkboxLabel}
                    />
                  </GridItem>
                </GridContainer>
              )}
              
              {/* Sub-Account Creation */}
              {!credentials.account_master && (
                <GridContainer>
                  <GridItem xs={12} sm={4}>
                    <RegularButton
                      color="info"
                      size="sm"
                      className={classes.shopButton}
                      onClick={this.fetchLightspeedRetailMasterTokens}
                      disabled={loadingMasterTokens}
                    >
                      <SmallUppercase light>
                        {loadingMasterTokens ? 'Loading Master Accounts...' : 'Fetch Master Accounts'}
                      </SmallUppercase>
                    </RegularButton>
                  </GridItem>
                  
                  {masterTokens.length > 0 && (
                    <>
                      <GridItem xs={12} sm={4}>
                        <FormControl fullWidth className={classes.formControl}>
                          <InputLabel htmlFor="master-token-select">
                            Select Master Account
                          </InputLabel>
                          <Select
                            id="master-token-select"
                            value={selectedMasterToken ? selectedMasterToken.account_id : ""}
                            onChange={this.onMasterTokenSelect}
                            MenuProps={{ className: classes.selectMenu }}
                            classes={{ select: classes.select }}
                            fullWidth
                            inputProps={{
                              name: "masterToken",
                            }}
                          >
                            {masterTokens.map((token, i) => (
                              <MenuItem
                                key={`token_${i}`}
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelectedMultiple,
                                }}
                                value={token.account_id}
                              >
                                {`${token.store_id} - ${token.store_name}`} (ID: {token.account_id})
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </GridItem>
                    </>
                  )}
                  {credentials.account_id?.length > 0 && (
                    <GridItem xs={12} sm={4}>
                      <CustomInput
                        labelText="Sub-Account ID"
                        formControlProps={{
                          fullWidth: true,
                          margin: "dense"
                        }}
                        inputProps={{
                          value: credentials.account_id,
                          disabled: true
                        }}
                      />
                    </GridItem>
                  )}
                </GridContainer>
              )}
              
              <Divider style={{ margin: '24px 0' }} />
              
              {/* Shop Selection */}
              <h4 className={classes.sectionSubtitle}>Lightspeed Shop Selection</h4>
              <GridContainer>
                <GridItem xs={12} sm={4}>
                  <RegularButton
                    color="info"
                    size="sm"
                    className={classes.shopButton}
                    onClick={this.fetchLightspeedShops}
                    disabled={loadingShops}
                  >
                    <SmallUppercase light>
                      {loadingShops ? 'Loading Shops...' : 'Fetch Shops'}
                    </SmallUppercase>
                  </RegularButton>
                </GridItem>
                
                {lightspeedShops.length > 0 && (
                  <GridItem xs={12} sm={4}>
                    <FormControl fullWidth className={classes.formControl}>
                      <InputLabel htmlFor="lightspeed-shop-select">
                        Select Shop
                      </InputLabel>
                      <Select
                        id="lightspeed-shop-select"
                        value={selectedShop ? selectedShop.shopID : ""}
                        onChange={this.onShopSelect}
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        fullWidth
                        inputProps={{
                          name: "lightspeedShop",
                        }}
                      >
                        {lightspeedShops.map((shop, i) => (
                          <MenuItem
                            key={`shop_${i}`}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelectedMultiple,
                            }}
                            value={shop.shopID}
                          >
                            {shop.name} (ID: {shop.shopID})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                )}
              </GridContainer>
            </div>
          )}
        </DialogContent>
        
        <DialogActions className={classes.dialogActions}>
          <RegularButton
            className={classes.actionButton}
            color="green"
            size="sm"
            onClick={this.testCredentials}
            disabled={!selected_provider}
          >
            <SmallUppercase light>Test Credentials</SmallUppercase>
          </RegularButton>
          <RegularButton
            className={classes.actionButton}
            color="danger"
            size="sm"
            onClick={() => {
              this.setState({credentials:{}, selected_provider:null});
              this.props.closeAPIDialog(false)
            }}
          >
            <SmallUppercase light>Cancel</SmallUppercase>
          </RegularButton>
          <RegularButton
            className={classes.actionButton}
            color="info"
            size="sm"
            onClick={()=>{
              if(this.state.selected_provider) {
                this.submit();
              } else {
                this.removeCredentials();
              }
            }}
          >
            <SmallUppercase light>{selected_provider ? 'Save' : 'Remove Credentials'}</SmallUppercase>
          </RegularButton>
        </DialogActions>
      </Dialog>
    )
  }
}
export default connect((state) => ({
  stores: state.app.stores,
  user: state.app.user,
}))(withStyles(styles)(SellerAPIDialog));